import { render, staticRenderFns } from "./AnnouncementDates.vue?vue&type=template&id=4a34df16&scoped=true&"
import script from "./AnnouncementDates.vue?vue&type=script&lang=js&"
export * from "./AnnouncementDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a34df16",
  null
  
)

export default component.exports